enum AttributeCategory {
	COMPANY = 'company',
	SHIP = 'ship',
	PREFERENCES = 'preferences',
	CERTIFICATE = 'certificate'
}

export default AttributeCategory
